var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReviewArrow = function SvgReviewArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "review_arrow_svg__a",
    width: 12,
    height: 12,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    stroke: "#1474FA",
    d: "M.5.5h11v11H.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#review_arrow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1474FA",
    d: "M11.71 6.46a.65.65 0 0 0 0-.92L7.573 1.404a.65.65 0 1 0-.92.919L10.332 6 6.654 9.677a.65.65 0 0 0 .92.92zM.75 6v.65h10.5v-1.3H.75z"
  }))));
};
export default SvgReviewArrow;